export function educationStageListByFilterQuery(filter) {
  const query = `{educationStageListByFilter(filter: ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')}){id, name, active, description}}`;
  return query;
}

export function educationStageListAllQuery() {
  const query = '{educationStageListAll{id, name, active}}';
  return query;
}

export function educationStageListIdAndName() {
  const query = '{educationStageListAll{id, name}}';
  return query;
}

export function removeEducationStageMutation(id) {
  const query = `mutation {educationStageRemove(id: ${id})}`;
  return query;
}

export function saveEducationStageMutation(values) {
  const query = `mutation {
    educationStageSave(                              
          educationStage: {id: ${values.id ? values.id : 0}
                        , name: "${
                          values.name
                        }"                                            
                        , description: """${values.description}"""
                        , active: ${values.active}
                        , filterByStatus: false                                        
                        , updaterId: 0
                    }),
        {id}
      }`;
  return query;
}
